import styled from "styled-components";
import { colors } from './../../utils/styles/colors';
import { media } from './../../utils/styles/media';
import { networkRanges } from "../../utils/styles/networks";

export const MyProfileContainer = styled.div`

    font-family: 'Open Sans',  sans-serif;
    .banner{
        background-color: #000000;
        display: flex;
        flex-direction: column;
        padding: 30px 50px ;
        min-height: 680px;
        .goBack{
            display: flex;
            margin-bottom: 20px;
            margin-left: 50px;
            cursor: pointer;
            width: 230px;
            .backIcon{
                width: 40px;
                margin-right: 15px;
            }
            .backText{
                color: #ffffff;
                font-size: 2.3rem;
                font-weight: 500;
            }
        }
        .bannerInformation{
            display: flex;
            justify-content: space-between;
            margin-top: 50px;
            .networkContainer{
                color: #ffffff;
                display: flex;
                position: relative;
                a{
                    text-decoration:none;
                    color:#ffffff;
                }
                .imageEdit{
                    position: absolute;
                    z-index: 100;
                    top:15px;
                    left: 450px;
                    background-color: transparent;
                    border: none;
                    .editPhoto{
                        cursor: pointer;
                        width: 60px;
                    }
                    input[type="file"]{
                        display: none;
                    }
                }
                
                .play{
                    position: absolute;
                    z-index: 100;
                    width : 120px;
                    height: 120px;
                    top:590px;
                    left: 265px;
                    border-radius: 50%;
                    cursor: pointer;
                }
                
                .networks{
                    position: relative;
                    text-align: end;
                    margin-top: 10px;
                    left: 430px;
                    width: 700px;
                    .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        margin: 8px 0 5px;
                        hr{
                            //width: 58%;
                            width: 100%;
                            border: 3px solid #ffffff;
                        } 
                        svg{
                            width: 60px;
                            height: 60px;
                            margin-right: 10px; 
                        }
                        span{
                            font-weight: 700;
                            font-size: 2rem;
                            white-space: nowrap;
                        }
                        .delete{
                            width: 25px;
                            position: absolute;
                            left: 105%;
                            cursor: pointer;
                        }
                    }
                    .facebookCount{
                        svg{
                            margin-left: -13px;
                            margin-right: 3px;
                            margin-top: 3.3px;
                        }
                    }
                    .tiktokCount{
                        svg{
                            margin-left: -7px;
                        }
                    }
                    .twitterCount{
                        svg{
                            margin-left: -7px;
                        }
                    }
                    .youtubeCount:hover{
                        hr{
                            border-color: red;
                        }
                        span{
                            color: red;
                        }
                        svg{
                            path{
                                fill:red;
                            }
                        }
                    }
                    .twitterCount:hover{
                        hr{
                            border-color: ${colors.twitter};
                        }
                        span{
                            color: ${colors.twitter};
                        }
                        svg{
                            path{
                                fill:${colors.twitter};
                            }
                        }
                    }
                    .facebookCount:hover{
                        hr{
                            border-color: ${colors.facebook};
                        }
                        span{
                            color: ${colors.facebook};
                        }
                        svg{
                            path{
                                fill:${colors.facebook};
                            }
                        }
                    }
                    .instagramCount:hover{
                        hr{
                            border-color: ${colors.hightlight};
                        }
                        span{
                            color: ${colors.hightlight};
                        }
                        svg{
                            path{
                                fill:${colors.hightlight};
                            }
                        }
                    }
                    .tiktokCount:hover{
                        hr{
                            border-color: ${colors.tiktok};
                        }
                        span{
                            color: ${colors.tiktok};
                        }
                        svg{
                            path{
                                filter: drop-shadow(-10px -10px 0px 0px ${colors.tiktok2}, -50px -50px 0px -30px );
                            }
                        }
                    }

                    .networkEmpty{
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        .network{
                            //padding-top: 12px ;
                            font-size: 2.2rem;
                            font-weight: lighter;
                            //cursor: pointer; 
                        }
                        .facebookButton{
                            background-color: transparent;
                            font-size: 2.2rem;
                            font-weight: lighter;
                            color: #ffffff;
                            font-family: 'Open Sans',  sans-serif;
                            border: none;
                            padding: 0;
                            //padding-top: 12px ;
                            //cursor: pointer;
                        }
                        .noConectLine{
                            color: #ffffff;
                            width: 100%;
                        }
                    }
                }
            }
            .data{
                margin-right: 50px;
                width: 1000px;
                font-family: 'Open Sans',  sans-serif;
                .fileName{
                    display: flex;
                    //align-items: center;
                    align-items: baseline;
                    margin-bottom: 2px;
                    .name{
                            color: #ffffff;
                            font-size: 4rem;
                            font-weight: bold;
                    }
                    .checkContainer{
                            background-color: #000000;
                            width: 35px;
                            border-radius: 50%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-left: 15px; 
                            .check{
                                width: 100%;
                                height: 100%;
                            }
                        }                 

                }
                .firstFile, .lastFile{
                    display: flex;
                    position: relative; 
                    .languageContainer{
                        display: flex;
                    }
                    .item{
                        display: flex;
                        .city{
                            color: ${colors.hightlight};
                            font-size: 2.3rem;
                            font-weight: 600;
                        }
                        .language{
                            color: #ffffff;
                            font-size: 2.3rem;
                            font-weight: 600;
                            span{
                                white-space: nowrap;
                            }
                        }
                        .categories{
                            color: ${colors.hightlight};
                            font-size: 2.2rem;
                            font-weight: 600;
                            text-transform: lowercase;
                        }
                        .edit{
                            margin-top: 5px;
                            margin-left: 10px;
                            margin-right: 25px;
                            width: 30px;
                            height: 30px;
                            cursor: pointer;
                            align-self: flex-start;
                        }
                        .options{
                            color: #000000;
                            position: absolute;
                            z-index: 150;
                            top: 60px;
                            background-color: #ffffff;
                            padding: 20px 30px;
                            border-radius: 5px;
                            display: flex;
                            flex-direction: column;
                            width: 400px;
                            .apply{                                        
                                font-size: 1.3rem;
                                color: ${colors.hightlight};
                                text-decoration: underline;
                                position: sticky;
                                top:0;
                                cursor: pointer;
                                align-self: flex-end;
                                margin-bottom: 5px;
                            }
                            .cityInput{
                                padding: 6px 8px;
                                border-radius: 10px;
                                border: 1px solid ${colors.grey};
                                outline: none;
                                margin: 10px 0;
                                font-size: 1.2rem;
                                font-family: 'Open Sans', sans-serif;
                                ::placeholder{
                                    font-size: 1.2rem; 
                                }
                            }

                            .option{
                                margin-bottom: 5px;
                                font-size: 1.2rem;
                                input[type="checkbox"]{
                                    margin-right: 15px;
                                    -ms-transform: scale(2); /* IE */
                                    -moz-transform: scale(2); /* FF */
                                    -webkit-transform: scale(2); /* Safari y Chrome */
                                    accent-color: ${colors.hightlight};
                                }
                            }
                        }
                    }
                    .share{
                        margin-right: 20px;
                        margin-top: 5px;
                        .shareIcon{
                            width: 35px;
                            height: 35px;
                            cursor: pointer;
                        }
                    }
                    .scoreContainer{
                        display: flex;
                        align-items: flex-start;
                        .score{
                            color: #ffffff;
                            font-size: 2.3rem;
                            font-weight: 600;
                        }
                        .star{
                            margin-top: 9px;
                            margin-left: 8px;
                            width: 30px;
                            height: 30px;
                        }
                    }
                }
                .descriptionContainer{
                    margin-top: 15px;
                    display: flex;
                    align-items: flex-end;
                    color: #ffffff;
                    .writeDescription{
                        background-color: #ffffff;
                        width: 100%;
                        padding: 20px 30px;
                        display: flex;
                        flex-direction: column;
                        border-radius: 10px;
                        .apply{
                            font-size: 1.3rem;
                            color: ${colors.hightlight};
                            text-decoration: underline;
                            position: sticky;
                            top:0;
                            cursor: pointer;
                            align-self: flex-end; 
                            margin-bottom:5px;  
                        }
                        textarea{
                            width: 100%;
                            height: 120px;
                            padding: 20px;
                            outline: none;
                            border-radius: 10px;
                            border: 1px solid ${colors.grey};
                            font-size: 1.2rem;
                            font-family: 'Open Sans', sans-serif;
                        }
                        .maxDescription{
                            color: ${colors.darkGrey};
                            font-size: 1rem;
                            //text-align: end;
                        }
                    }
                    .descriptionEmpty{
                        width: 90%;
                        .description{
                            font-size: 2.2rem;
                        }
                        .item{
                            hr{
                                margin-top: 40px;  
                            }
                            hr:first-child{
                                margin-top: 10px;  
                            }
                        }

                    }
                    .descriptionContent{
                        max-height: 150px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        inline-size: 100%;
                        overflow-wrap: break-word;
                        p{
                            font-weight: lighter;
                            font-size: 2.2rem;
                        }
                    } 
                    .edit{
                        margin: 0 10px;
                        width: 30px;
                        height: 30px;
                        cursor: pointer;
                    }                   
                }
                .lastFile{
                    margin-top: 25px;
                }

            }
            .networkMobile{
                display: none;
            }
        }
        
    }
    .myProfileBody{
        min-height: 600px;
        padding:30px 95px 30px 95px ;
    }

    /**----------Responsive------------ */
    ${media.extralargeDesktop}{
        .banner{
            min-height: 580px;
            .bannerInformation{
                margin-top: 30px;
                .networkContainer{
                    .imageEdit{
                        left: 380px;
                        .editPhoto{
                            width: 45px;
                        }
                    }
                    .play{
                        width : 100px;
                        height: 100px;
                        top:500px;
                        left: 225px;
                    }
                    .networks{
                        left: 375px;
                        width: 520px;
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            hr{
                                //width: 54%;
                                border: 2.5px solid #ffffff;
                            }
                            svg{
                                width: 50px;
                                height: 50px;
                            }
                            span{
                                font-size: 1.8rem;
                            }
                        }
                        .networkEmpty{
                            .network{
                                font-size: 2rem;
                            }
                            .facebookButton{
                                font-size: 2rem;
                            }
                        }  
                    }
                }
                .data{
                    width: 840px;
                    .fileName{
                        .name{
                            font-size: 3.5rem;
                        }
                        .checkContainer{
                            width: 30px;
                        }                 
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.9rem;
                            }
                            .language{
                                font-size: 1.9rem;
                            }
                            .categories{
                                font-size: 1.8rem;
                            }
                            .edit{
                                width: 28px;
                                height: 28px;
                            }
                        }
                        .share{
                            .shareIcon{
                                width: 30px;
                                height: 30px;
                            }
                        }
                        .scoreContainer{
                            .score{
                                font-size: 1.9rem;
                            }
                            .star{
                                width: 28px;
                                height: 28px;
                                margin-top: 6px;
                            }
                        }
                    }
                }
            }
        }
    }

    ${media.largeDesktop}{
        .banner{
            padding: 30px 30px ;
            min-height: 480px;
            .goBack{
                width: 180px;
                margin-left: 50px;
                .backIcon{
                    width: 35px;
                }
                .backText{
                    font-size: 1.8rem;
                }
            }
            .bannerInformation{
                margin-top: 30px;
                .networkContainer{
                    .imageEdit{
                        left: 320px;
                        .editPhoto{
                            width: 40px;
                        }
                    }
                    .play{
                        width : 90px;
                        height: 90px;
                        top:405px;
                        left: 180px;
                    }
                    .networks{
                        left: 313px;
                        width: 450px;
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            //margin-top: 20px;
                            margin-bottom: 0px;
                            svg{
                                width: 48px;
                                height: 48px;
                            }
                            span{
                                font-size: 1.8rem;
                            }
                            .delete{
                                width: 20px;  
                            }
                        }
                        .networkEmpty{
                            .network{
                                font-size: 1.8rem; 
                            }
                            .facebookButton{
                                font-size: 1.8rem;
                            }
                        }
                    }
                }

                .data{
                    width: 770px;
                    .fileName{
                        .name{
                            font-size: 3.3rem;
                        }
                        .checkContainer{
                            width: 30px;
                        }                 
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.8rem;
                            }
                            .language{
                                font-size: 1.8rem;
                            }
                            .categories{
                                font-size: 1.7rem;
                            }
                            .edit{
                                margin-left: 8px;
                                margin-right: 15px;
                                width: 25px;
                                height: 25px;
                            }
                            .options{
                                top: 45px;
                                padding: 15px 25px;
                                width: 350px;
                                /* .apply{                                        
                                    font-size: 1.3rem;
                                } */
                                .cityInput{
                                    padding: 6px 8px;
                                    //font-size: 1.2rem;
                                }
                                .option{
                                    //font-size: 1.2rem;
                                    input[type="checkbox"]{
                                        -ms-transform: scale(1.5); /* IE */
                                        -moz-transform: scale(1.5); /* FF */
                                        -webkit-transform: scale(1.5); /* Safari y Chrome */
                                        margin-right: 8px;
                                    }
                                }
                            }
                        }
                        .share{
                            margin-right: 15px;
                            margin-top: 5px;
                            .shareIcon{
                                width: 27px;
                                height: 27px;
                            }
                        }
                        .scoreContainer{
                            display: flex;
                            align-items: flex-start;
                            .score{
                                color: #ffffff;
                                font-size: 1.8rem;
                                font-weight: 600;
                            }
                            .star{
                                margin-top: 5px;
                                margin-left: 8px;
                                width: 27px;
                                height: 27px;
                            }
                        }
                    }
                    .descriptionContainer{
                         .writeDescription{
                            padding: 10px 20px;
                            .apply{
                                font-size: 1.1rem;
                            }
                             textarea{
                                font-size: 1.2rem;
                                height: 90px;
                            }
                            .maxDescription{
                                font-size: 0.9rem;
                            }
                        } 
                        .descriptionEmpty{
                            width: 90%;
                            .description{
                                font-size: 1.8rem;
                            }
                            .item{
                                hr{
                                    margin-top: 35px;  
                                }
                            }

                        }
                        .descriptionContent{
                            max-height: 120px;
                            p{
                                font-size: 1.8rem;
                            }
                        } 
                        .edit{
                            margin: 0 10px;
                            width: 30px;
                            cursor: pointer;
                        }                   
                    }
                    .lastFile{
                        margin-top: 25px;
                    }
                }
            }
        }
        .myProfileBody{
            padding:30px 70px 30px 70px ;
        } 
    }

    ${media.specialScreen}{
        .banner{
            min-height: 400px;
            .goBack{
                width: 160px;
                .backIcon{
                    width: 28px;
                }
                .backText{
                    font-size: 1.4rem;
                }
            }
            .bannerInformation{
                margin-top: 20px;
                .networkContainer{
                    .imageEdit{
                        left: 270px;
                        .editPhoto{
                            width: 35px;
                        }
                    }
                    .play{
                        width : 70px;
                        height: 70px;
                        top:345px;
                        left: 155px;
                    }
                    .networks{
                        left: 270px;
                        width: 350px;
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            svg{
                                width: 40px;
                                height: 40px;
                            }
                            span{
                                font-size: 1.6rem;
                            }
                        }
                        .networkEmpty{
                            .network{
                                font-size: 1.3rem; 
                            }
                            .facebookButton{
                                font-size: 1.3rem;
                            }
                        }
                    }
                }
                .data{
                    width:610px;
                    .fileName{
                        .name{
                            font-size: 2.5rem;
                        }
                        .checkContainer{
                            width: 25px;
                        }                 
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.4rem;
                            }
                            .language{
                                font-size: 1.4rem;
                            }
                            .categories{
                                font-size: 1.3rem;
                            }
                            .edit{
                                margin-left: 8px;
                                margin-right: 15px;
                                width: 20px;
                                height: 20px;
                            }
                            .options{
                                top: 35px;
                                padding: 10px 20px;
                                width: 300px;
                                /* .apply{                                        
                                    font-size: 1rem;
                                } */
                                .cityInput{
                                    padding: 6px 8px;
                                    //font-size: 1.1rem;
                                }
                                .option{
                                    //font-size: 1.1rem;
                                    input[type="checkbox"]{
                                        margin-right: 8px;
                                        -ms-transform: scale(1.2); /* IE */
                                        -moz-transform: scale(1.2); /* FF */
                                        -webkit-transform: scale(1.2); /* Safari y Chrome */
                                    }
                                }
                            }
                        }
                        .share{
                            margin-right: 15px;
                            margin-top: 5px;
                            .shareIcon{
                                width: 23px;
                                height: 23px;
                            }
                        }
                        .scoreContainer{
                            display: flex;
                            align-items: flex-start;
                            .score{
                                color: #ffffff;
                                font-size: 1.4rem;
                                font-weight: 600;
                            }
                            .star{
                                margin-top: 4px;
                                margin-left: 6px;
                                width: 21px;
                                height: 21px;
                            }
                        }
                    }
                    .descriptionContainer{
                         .writeDescription{
                            padding: 10px 15px;
                            .apply{
                                font-size: 1rem;
                            }
                            textarea{
                                font-size: 1.1rem;
                                height: 80px;
                            } 
                            .maxDescription{
                                font-size: 0.8rem;
                            }
                        } 
                        .descriptionEmpty{
                            width: 90%;
                            .description{
                                font-size: 1.3rem;
                            }
                            .item{
                                hr{
                                    margin-top: 30px;  
                                }
                            }

                        }
                        .descriptionContent{
                            p{
                                font-size: 1.3rem;
                            }
                        } 
                        .edit{
                            margin: 0 10px;
                            width: 20px;
                            height: 20px;
                            cursor: pointer;
                        }                   
                    }
                    .lastFile{
                        margin-top: 25px;
                    }
                }
            }
        }
        .myProfileBody{
            padding:20px 80px 30px 80px ;
        } 
    }

    ${media.bigmacdesktop}{
        .banner{
            min-height: 360px;
            .goBack{
                width: 140px;
                margin-left: 40px;
                .backIcon{
                    width: 26px;
                }
                .backText{
                    font-size: 1.2rem;
                }
            }
            .bannerInformation{
                .networkContainer{
                    .imageEdit{
                        left: 250px;
                        top: 12px;
                        .editPhoto{
                            width: 33px;
                        }
                    }
                    .play{
                        width : 60px;
                        height: 60px;
                        top:330px;
                        left: 150px;
                    } 
                    .networks{
                        left: 240px;
                        width: 440px;
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            hr{
                                //width: 57%;
                                border: 2.5px solid #ffffff;
                            }
                            svg{
                                width: 35px;
                                height: 35px;
                            }
                            span{
                                font-size: 1.4rem;
                            }
                            .delete{
                            width: 15px;
                            }
                        }
                    }
                }
                .data{
                    width:580px;
                    //background-color: orange;
                    .fileName{
                        .name{
                            font-size: 2.4rem;
                        }
                        .checkContainer{
                            width: 25px;
                        }                 
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.3rem;
                            }
                            .language{
                                font-size: 1.3rem;
                            }
                            .categories{
                                font-size: 1.1rem;
                            }
                            .edit{
                                margin-left: 8px;
                                margin-right: 18px;
                                width: 18px;
                                height: 18px; 
                            }
                            .options{
                                top:30px;
                                padding: 8px 10px;
                                width: 250px;
                                .apply{                                        
                                    font-size: 0.9rem;
                                }
                                .cityInput{
                                    font-size: 1.1rem;
                                    ::placeholder{
                                        font-size: 1.1rem; 
                                    }
                                }
                                .option{
                                    font-size: 1.1rem;
                                    input[type="checkbox"]{
                                        margin-right: 8px;
                                        -ms-transform: scale(1); /* IE */
                                        -moz-transform: scale(1); /* FF */
                                        -webkit-transform: scale(1); /* Safari y Chrome */
                                    }
                                }
                            }
                        }
                        .share{
                            .shareIcon{
                                width: 21px;
                                height: 21px;
                            }
                        }
                        .scoreContainer{
                            display: flex;
                            align-items: flex-start;
                            margin-top: 2px;
                            .score{
                                font-size: 1.2rem;
                            }
                            .star{
                                margin-top: 5px;
                                margin-left: 6px;
                                width: 17px;
                                height: 17px;
                            }
                        }
                    }
                    .descriptionContainer{
                        .writeDescription{
                            padding:10px;
                            .apply{
                                font-size: 0.9rem;
                            }
                            textarea{
                                font-size: 1.1rem;
                                padding: 15px;
                                height: 70px;
                            }
                            .maxDescription{
                                font-size: 0.7rem;
                            }
                        }
                        .edit{
                            width: 18px;
                            height: 18px;
                        }
                    }
                    
                }
            }
        }
        .myProfileBody{
            padding:30px 80px 30px 80px ;
        }
    }

    ${media.macdesktop}{
        .banner{
            min-height: 340px;
            .goBack{
                width: 130px;
                margin-left: 40px;
                .backIcon{
                    width: 24px;
                }
                .backText{
                    font-size: 1.1rem;
                }
            }
            .bannerInformation{
                .networkContainer{
                    .imageEdit{
                        left: 240px;
                        top: 12px;
                        .editPhoto{
                            width: 28px;
                        }
                    }
                    .play{
                        width : 55px;
                        height: 55px;
                        top:312.5px;
                        left: 142.5px;
                    } 
                    .networks{
                        left: 235px;
                        width: 400px;
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            hr{
                                //width: 57%;
                                border: 2.5px solid #ffffff;
                            }
                            svg{
                                width: 35px;
                                height: 35px;
                            }
                            span{
                                font-size: 1.4rem;
                            }
                        }
                    }
                }
                .data{
                    width:575px;
                    margin-right: 40px;
                    .fileName{
                        .name{
                            font-size: 2.4rem;
                        }
                        .checkContainer{
                            width: 25px;
                        }                 
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.3rem;
                            }
                            .language{
                                font-size: 1.3rem;
                            }
                            .categories{
                                font-size: 1.1rem;
                            }
                            .edit{
                                margin-left: 8px;
                                margin-right: 20px;
                                width: 18px;
                                height: 18px; 
                            }
                            .options{
                                top:30px;
                                padding: 8px 10px;
                                width: 250px;
                                /* .apply{                                        
                                    font-size: 0.8rem;
                                } */
                                /* .cityInput{
                                    font-size: 0.9rem;
                                } */
                                .option{
                                    //font-size: 0.9rem;
                                    input[type="checkbox"]{
                                        margin-right: 8px;
                                        -ms-transform: scale(1); /* IE */
                                        -moz-transform: scale(1); /* FF */
                                        -webkit-transform: scale(1); /* Safari y Chrome */
                                    }
                                }
                            }
                        }
                        .share{
                           // background-color: green;
                            .shareIcon{
                                width: 20px;
                                height: 20px;
                            }
                        }
                        .scoreContainer{
                            display: flex;
                            align-items: flex-start;
                            margin-top: 1px;
                            .score{
                                font-size: 1.2rem;
                            }
                            .star{
                                margin-top: 5px;
                                margin-left: 4px;
                                width: 17px;
                                height: 17px;
                            }
                        }
                    }
                    .descriptionContainer{   
                        .descriptionContent{
                            max-height: 110px;
                        } 
                    }
                }
            }
        }

        .myProfileBody{
            padding:30px 70px 30px 70px ;
        }
    }

    ${media.desktop}{
        .banner{
            padding: 20px 20px ;
            min-height: 300px;
            .goBack{
                width: 120px;
                margin-left: 40px;
                .backIcon{
                    width: 20px;
                }
                .backText{
                    font-size: 1rem;
                }
            }
            
            .bannerInformation{
                margin-top: 10px;
                .networkContainer{ 
                    .imageEdit{
                        left: 215px;
                        top:10px;
                        .editPhoto{
                            width: 23px;
                        }
                    }
                    .play{
                        width : 50px;
                        height: 50px;
                        top:275px;
                        left: 125px;
                    }                 
                    .networks{
                        left: 205px;
                        width: 350px;
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                             hr{
                                border: 2px solid #ffffff;
                            } 
                            svg{
                                width: 28px;
                                height: 28px;
                            }
                            span{
                                font-size: 1.1rem;
                            }
                        }
                        .networkEmpty{
                            .network{
                                font-size: 1rem; 
                            }
                            .facebookButton{
                                font-size: 1rem;
                            }
                        }
                        /* .instagramCount{
                            svg{
                                margin-left: 0px;
                            }
                        }
                        .facebookCount{
                            svg{
                                margin-left: -11px;
                            }
                        }
                        .tiktokCount{
                            svg{
                                margin-left: -7px;
                            }
                        } */
                    }
                }
                .data{
                    width: 525px;
                    .fileName{
                        .name{
                            font-size: 2.4rem;
                        }
                        .checkContainer{
                            width: 23px;
                        }                 
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.2rem;
                            }
                            .language{
                                font-size: 1.2rem;
                            }
                            .categories{
                                font-size: 1.1rem;
                            }
                            .edit{
                                margin-left: 6px;
                                margin-right: 16px;
                                width: 18px;
                                height: 18px; 
                            }
                            .options{
                                top:30px;
                                padding: 8px 10px;
                                width: 250px;
                                .apply{                                        
                                    font-size: 0.8rem;
                                }
                                .cityInput{
                                    font-size: 0.9rem;
                                    ::placeholder{
                                        font-size: 0.9rem; 
                                    }
                                }
                                .option{
                                    font-size: 0.9rem;
                                    input[type="checkbox"]{
                                        margin-right: 8px;
                                        -ms-transform: scale(1); /* IE */
                                        -moz-transform: scale(1); /* FF */
                                        -webkit-transform: scale(1); /* Safari y Chrome */
                                    }
                                }
                            }
                        }
                        .share{
                            margin-right: 12px;
                            .shareIcon{
                                width: 18px;
                                height: 18px;
                            }
                        }
                        .scoreContainer{
                            display: flex;
                            align-items: flex-start;
                            .score{
                                font-size: 1.2rem;
                            }
                            .star{
                                margin-top: 5px;
                                margin-left: 4px;
                                width: 17px;
                                height: 17px;
                            }
                        }
                    }
                    .descriptionContainer{
                        margin-top: 0px;
                        .writeDescription{
                            .apply{
                                font-size: 0.8rem;
                            }
                            textarea{
                                font-size: 0.9rem;
                                height: 60px;
                                padding: 10px;
                            }
                            .maxDescription{
                                font-size: 0.6rem;
                            }
                        }
                        .descriptionEmpty{
                            width: 90%;
                            .description{
                                font-size: 1.1rem;
                            }
                            .item{
                                hr{
                                    margin-top: 20px;  
                                }
                                hr:first-child{
                                    margin-top: 5px;  
                                }
                            }

                        }
                        .descriptionContent{
                            p{
                                font-size: 1.1rem;
                            }
                        } 
                        .edit{
                            width: 18px;
                            height: 18px;
                        }                   
                    }
                    .lastFile{
                        margin-top: 5px;
                    }
                }
            }     
        }

        .myProfileBody{
            padding:30px 60px 30px 60px ;
        } 

    }

    ${media.mediumDesktop}{
        .banner{
            min-height: 280px;
            .bannerInformation{
                .networkContainer{ 
                    .imageEdit{
                        left: 210px;
                    }
                    .play{
                        width : 50px;
                        height: 50px;
                        top:265px;
                        left: 120px;
                    }                 
                    .networks{
                        left: 215px;
                        width: 260px;
                        .networkEmpty{
                            .network{
                                font-size: 0.9rem; 
                            }
                            .facebookButton{
                                font-size: 0.9rem;
                            }
                        }
                    }
                }
                .data{
                    width: 480px;
                    margin-right:25px;
                    .fileName{
                        .name{
                            font-size: 2.2rem;
                        }
                        .checkContainer{
                            width: 22px;
                        }                 
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1.1rem;
                            }
                            .language{
                                font-size: 1.1rem;
                            }
                            .categories{
                                font-size: 1rem;
                            }
                            .edit{
                                margin-left: 6px;
                                margin-right: 12px;
                            }
                        }
                        .share{
                            .shareIcon{
                                width: 18px;
                            }
                        }
                        .scoreContainer{
                            display: flex;
                            align-items: flex-start;
                            .score{
                                font-size: 1.2rem;
                            }
                            .star{
                                margin-top: 5px;
                                margin-left: 7px;
                                width: 17px;
                                height: 17px;
                            }
                        }
                    }
                    .descriptionContainer{
                        margin-top: 0px;
                        /* .writeDescription{
                            .apply{
                                font-size: 0.8rem;
                            }
                            textarea{
                                font-size: 0.9rem;
                                height: 60px;
                            }
                        } */
                        .descriptionEmpty{
                            width: 90%;
                            .description{
                                font-size: 1.1rem;
                            }
                            .item{
                                hr{
                                    margin-top: 20px;  
                                }
                                hr:first-child{
                                    margin-top: 5px;  
                                }
                            }

                        }
                        .descriptionContent{
                            max-height: 120px;
                            p{
                                font-size: 1.1rem;
                            }
                        } 
                        .edit{
                            width: 18px;
                            height: 18px;
                        }                   
                    }
                    .lastFile{
                        margin-top: 5px;
                    }
                }
            }     
        }

        .myProfileBody{
            padding:30px 60px 30px 60px ;
        } 

    }
    
    ${media.smallDesktop}{
        .banner{
            .bannerInformation{
                .networkContainer{
                    .imageEdit{
                        left: 210px;
                        .editPhoto{
                            width: 25px;
                        }
                    }
                    .play{
                        width : 50px;
                        height: 50px;
                        top:255px;
                        left: 115px;
                    }
                    .networks{
                        left: 205px;
                        width: 240px;
                        .youtubeCount, .twitterCount, .tiktokCount, .facebookCount, .instagramCount{
                            svg{
                                width: 26px;
                                height: 26px;
                            }
                        }
                    }
                }
                .data{
                    width: 460px;
                    margin-right: 10px;
                    .fileName{
                        .name{
                            font-size: 2.1rem;
                        }
                        .checkContainer{
                            width: 22px;
                        }                 
                    }
                    .firstFile, .lastFile{
                        .item{
                            .city{
                                font-size: 1rem;
                            }
                            .language{
                                font-size: 1rem;
                            }
                            .categories{
                                font-size: 0.9rem;
                            }
                            .edit{
                                margin-left: 6px;
                                margin-right: 12px;
                                width: 16px;
                                height: 16px; 
                            }
                            .options{
                                top:30px;
                                padding: 8px 10px;
                                width: 230px;
                                /* .apply{                                        
                                    font-size: 0.8rem;
                                } */
                                /* .cityInput{
                                    font-size: 0.9rem;
                                    ::placeholder{
                                        font-size: 0.9rem; 
                                    }
                                } */
                                .option{
                                    font-size: 0.9rem;
                                    input[type="checkbox"]{
                                        margin-right: 8px;
                                        -ms-transform: scale(1); /* IE */
                                        -moz-transform: scale(1); /* FF */
                                        -webkit-transform: scale(1); /* Safari y Chrome */
                                    }
                                }
                            }
                        }
                        .share{
                            .shareIcon{
                                width: 17px;
                                height: 17px;
                            }
                        }
                        .scoreContainer{
                            display: flex;
                            align-items: flex-start;
                            //margin-top: 1px;
                            .score{
                                font-size: 1rem;
                            }
                            .star{
                                margin-top: 3px;
                                margin-left: 4px;
                                width: 16px;
                                height: 16px;
                            }
                        }
                    }
                    .descriptionContainer{
                        margin-top: 0px;
                        /* .writeDescription{
                            .apply{
                                font-size: 0.8rem;
                            }
                            textarea{
                                font-size: 0.9rem;
                                height: 60px;
                            }
                        } */
                        .descriptionEmpty{
                            width: 90%;
                            .description{
                                font-size: 0.9rem;
                            }
                            .item{
                                hr{
                                    margin-top: 15px;  
                                }
                                hr:first-child{
                                    margin-top: 5px;  
                                }
                            }

                        }
                        .descriptionContent{
                            p{
                                font-size: 0.9rem;
                            }
                        } 
                        .edit{
                            width: 17px;
                            height: 17px;
                        }                   
                    }
                    .lastFile{
                        margin-top: 5px;
                    }
                }               
            }
        }
        .myProfileBody{
            padding:30px 30px 30px 30px ;
        } 
        
    }

    ${media.laptop}{
        .banner{
            .bannerInformation{
                flex-direction: column;
                align-items: center;
                .networkContainer{
                    .imageEdit{
                        .editPhoto{
                            width: 15px;
                            height: 15px;
                        }
                    }
                    .play{
                        width : 50px;
                        height: 50px;
                        top:255px;
                        left: 115px;
                    } 
                    .networks{
                        display: none;
                    }
                }
                .data{
                    margin-top: 40px;
                    width: 100%;
                    margin-right: 0px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .fileName{
                        margin-bottom: 10px;
                        .name{
                            font-size: 2.3rem;
                        }
                        .checkContainer{
                            width: 24px;
                        }                 
                    }
                    .firstFile{
                        .languageContainer{
                            .scoreContainer{
                                align-items: center;
                                margin-top: 0;
                                .star{
                                    margin-top: 0;
                                    margin-left: 5px;
                                }
                            }
                        }
                        .share{
                            margin-top: 2px;
                            .shareIcon{
                                width: 18px;
                                height: 18px;
                            }
                        }
                    }

                    .firstFile, .lastFile{
                        .item{
                            .edit{
                                width: 15px;
                                height: 15px; 
                            }
                            
                        }
                    }
                    .descriptionContainer{
                        width: 60%;
                        display: flex;
                        justify-content: center;
                         .writeDescription{
                            textarea{
                                height: 70px;
                            }
                        }
                        .edit{
                            width: 15px;
                            height: 15px;
                        }
                        .descriptionContent{
                            p{
                               text-align: center;
                            }
                        }
                    }
                } 
                .networkMobile{
                    margin-top: 10px;
                    display: block;
                    display: flex;
                    align-items: center;
                    .text{
                        color: #ffffff;
                        }
                    .network{
                        margin-left: 10px;
                        height: 40px;
                        width: 40px;
                        border-radius: 50%;
                        background-color: ${colors.greyChat};
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        //cursor: pointer;
                        position: relative;
                        .edit{
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 15px;
                            height: 15px;
                        }
                        .networkIcon{
                            width: 20px;
                            height: 20px;
                        }
                        .twitterLink{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                    .logged{
                        background-color: #000000;
                    }
                    .networkContainer{
                        position: relative;
                        .edit{
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 15px;
                            height: 15px;
                            }
                        .networkButton{
                            margin-left: 10px;
                            height: 40px;
                            width: 40px;
                            border-radius: 50%;
                            background-color: ${colors.greyChat};
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            border: none;
                            
                        }
                    }
                    
                    .edit{
                        margin-left: 10px;
                        width: 18px;
                        height: 18px;
                    }

                    .contentNetwork{
                        display: flex;
                        align-items: center;
                        .network{
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            .networkIcon{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .followersCount{
                            display: none;
                        }
                    }
                    
                    .contentNetwork:hover{
                        .network{
                            background-color: #000000;
                            z-index: 50;
                        }
                        .followersCount{
                            display: block;
                            color: #ffffff;
                            padding-left: 15px;
                            padding-right: 10px;
                            margin-left: -10px;
                            margin-right: 5px;
                            background-color: rgba(61, 61, 61, 0.4);
                            border-radius: 0 20px 20px 0;
                        }
                    }
                    
                }              
            }
        }
        .myProfileBody{
            padding:30px;
        }     
    }

    ${media.largeMobile}{
        .banner{
            .bannerInformation{
                .networkContainer{
                    .imageEdit{
                        left: 145px;
                        .editPhoto{
                            width: 12px;
                        }
                    }
                    .play{
                        width : 40px;
                        height: 40px;
                        top:160px;
                        left: 70px;
                    }
                }
                .data{
                    .fileName{
                        margin-bottom: 10px;
                        .name{
                            font-size: 1.6rem;
                        }
                        .checkContainer{
                            width: 18px;
                            height: 18px;
                            margin-left: 8px;
                        }                 
                    }
                    .firstFile, .lastFile{
                        flex-direction: column;
                        align-items: center;
                        .item{
                            .city{
                                font-size: 1rem;
                            }
                            .language{
                                font-size: 1rem;
                            }
                            .categories{
                                font-size: 0.9rem;
                            }
                            .edit{
                                margin-left: 3px;
                                margin-right: 8px;
                                width: 12px;
                                height: 12px; 
                            }
                            
                        }
                        .share{
                            margin-right: 10px;
                            .shareIcon{
                                width: 16px;
                                height: 16px;
                            }
                        }
                        .scoreContainer{
                            display: flex;
                            //align-items: flex-start;
                            .score{
                                font-size: 1rem;
                            }
                            .star{
                                //margin-top: 4px;
                                margin-left: 2px;
                                width: 15px;
                                height: 15px;
                            }
                        }
                    }
                    .descriptionContainer{
                        width: 80%;
                        .edit{
                            height: 12px;
                            width: 12px;
                        }
                    }
                } 
                .networkMobile{
                    .text{
                        font-size: 0.9rem;
                        }
                    .network{
                        margin-left: 6px;
                        height: 34px;
                        width: 34px;
                        .edit{
                            width: 12px;
                            height: 12px;
                        }
                        .networkIcon{
                            width: 18px;
                            height: 18px;
                        }
                    }
                    .networkContainer{ 
                        .edit{
                            width: 12px;
                            height: 12px;
                            }
                        .networkButton{
                            margin-left: 6px;
                            height: 36px;
                            width: 36px;
                        }
                    }

                    .contentNetwork{
                        .network{
                            width: 34px;
                            height: 34px;
                        }
                    }
                    
                    .contentNetwork:hover{
                        .followersCount{
                            font-size: 0.8rem;
                        }
                    }
                    
                    
                }              
            }
        }
        .myProfileBody{
            padding:30px 20px ;
        }     
    }

`

export const ProfileImage = styled.div`

    width: 650px; 
    height: 650px;
    background-image:url(${(props) => props.image});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50%;
    background-position: 50%;
    position: absolute;
    z-index: 50;

    /**--------Responsive-------- */
    ${media.extralargeDesktop}{
        width: 550px; 
        height: 550px;
    }

    ${media.largeDesktop}{
        width: 450px; 
        height: 450px;
    }

    ${media.specialScreen}{
        width: 380px; 
        height: 380px;
    }

    ${media.bigmacdesktop}{
        width: 360px; 
        height: 360px;
    }

    ${media.macdesktop}{
        width: 340px; 
        height: 340px;
    }

    ${media.desktop}{
        width: 300px; 
        height: 300px;
    }

    ${media.mediumDesktop}{
        width: 290px; 
        height: 290px;
    }

    ${media.smallDesktop}{
        width: 280px; 
        height: 280px;
    }

    ${media.laptop}{
        position: initial;
    }

    ${media.largeMobile}{
        width: 180px;
        height: 180px;

    }
`

export const NetworkCount = styled.div`

        position: relative;
        text-align: end;
        width: ${(props) => props.count < networkRanges.rango1 ? '58%' : props.count < networkRanges.rango2 ? '66%' : props.count < networkRanges.rango3 ? '74%' : props.count < networkRanges.rango4 ? '82%' : props.count < networkRanges.rango5 ? '91%' : '100%'};
        height: 80px;
        margin-top: 10px;
        .networkEmpty{
            cursor: ${(props) => (props.isAdmin) ? 'not-allowed' : 'pointer'};
            .network{
                cursor: ${(props) => (props.isAdmin) ? 'not-allowed' : 'pointer'};   
            }
            .facebookButton{
                cursor: ${(props) => (props.isAdmin) ? 'not-allowed' : 'pointer'};
            }
        }

        /**----------Responsive---------- */
        ${media.extralargeDesktop}{
            width: ${(props) => props.count < networkRanges.rango1 ? '64%' : props.count < networkRanges.rango2 ? '71%' : props.count < networkRanges.rango3 ? '78%' : props.count < networkRanges.rango4 ? '85%' : props.count < networkRanges.rango5 ? '92%' : '100%'};
            height: 70px;
        }

        ${media.largeDesktop}{
            height: 65px;
        }

        ${media.specialScreen}{
            width: ${(props) => props.count < networkRanges.rango1 ? '70%' : props.count < networkRanges.rango2 ? '76%' : props.count < networkRanges.rango3 ? '82%' : props.count < networkRanges.rango4 ? '88%' : props.count < networkRanges.rango5 ? '94%' : '100%'};
            height: 42px;
        }

        ${media.bigmacdesktop}{
            width: ${(props) => props.count < networkRanges.rango1 ? '58%' : props.count < networkRanges.rango2 ? '66%' : props.count < networkRanges.rango3 ? '74%' : props.count < networkRanges.rango4 ? '82%' : props.count < networkRanges.rango5 ? '91%' : '100%'};
            height: 40px;
        }

        ${media.macdesktop}{
            height: 38px;
        }

        ${media.desktop}{
            height: 35px; 
            margin-top: 5px;
        }

        ${media.mediumDesktop}{
            width: ${(props) => props.count < networkRanges.rango1 ? '65%' : props.count < networkRanges.rango2 ? '72%' : props.count < networkRanges.rango3 ? '79%' : props.count < networkRanges.rango4 ? '86%' : props.count < networkRanges.rango5 ? '93%' : '100%'};
            height: 33px;
        }

        ${media.smallDesktop}{
            width: ${(props) => props.count < networkRanges.rango1 ? '70%' : props.count < networkRanges.rango2 ? '76%' : props.count < networkRanges.rango3 ? '82%' : props.count < networkRanges.rango4 ? '88%' : props.count < networkRanges.rango5 ? '94%' : '100%'};
            height: 31px;
        }
                    
`